import React from "react"
import { ScrollView, View } from "react-native"
import { hasRole } from "../../../data/utility/ability"
import { useIsSoundMode } from "../../hooks/livekit/useParticipantState"

import { getTrackRefId } from "../liveKitUtils"
import { ParticipantTileM } from "./ParticipantTileM"

const FocusLayoutM = (props) => {
    const {
        stableTracks,
        setSelectedTrackSid,
        selectedTrackSid,
        miniMode,
        user,
        contentWidth,
        noDisplayName,
    } = props

    const isSoundOn = useIsSoundMode(user?.id)
    const isSilentMode =
        hasRole(user, "student") && !isSoundOn

    const handleParticipantClick = (trackRef) => {
        setSelectedTrackSid(getTrackRefId(trackRef))
    }

    const filteredTracks = (stableTracks.filter(
        (track) => getTrackRefId(track) !== selectedTrackSid
    ))?.filter(track => track?.participant?.identity?.split(".")[0] !== user?.id?.toString())

    const shownTracks =
        miniMode || !selectedTrackSid
            ? [
                  stableTracks?.find(
                      (track) => getTrackRefId(track) === selectedTrackSid
                  ) ?? stableTracks?.[0],
                  ...filteredTracks,
              ]
            : filteredTracks

    const selectedTrack = selectedTrackSid
        ? stableTracks?.find(
              (track) => getTrackRefId(track) === selectedTrackSid
          ) ?? stableTracks?.[0]
        : stableTracks?.[0]

    return (
        <View style={{ flex: 1, flexDirection: miniMode ? "column" : "row" }}>
            {!miniMode && selectedTrack && (
                <View style={{ flex: 1 }}>
                    <ParticipantTileM
                        trackRef={selectedTrack}
                        participants={props.participants}
                        style={{
                            width: "100%",
                            height: "100%",
                        }}
                    />
                </View>
            )}

            {shownTracks?.length > 0 && (
                <ScrollView
                    style={{
                        width: miniMode ? contentWidth : undefined,
                        maxWidth: miniMode ? undefined : 200,
                        flexShrink: 0,
                    }}
                    scrollEnabled={!miniMode}
                >
                    {shownTracks?.map(
                        (trackRef, index) =>
                            trackRef && (
                                <ParticipantTileM
                                    key={index}
                                    trackRef={trackRef}
                                    participants={props.participants}
                                    miniMode={props.miniMode}
                                    noDisplayName={noDisplayName}
                                    noOutOfApp
                                    onParticipantClick={() =>
                                        handleParticipantClick(trackRef)
                                    }
                                    style={{
                                        width: "100%",
                                        height:
                                            miniMode && isSilentMode ? 180 : 240,
                                        maxHeight: "100%",
                                        maxWidth: "100%",
                                        backgroundColor: "black",
                                    }}
                                />
                            )
                    )}
                </ScrollView>
            )}
        </View>
    )
}

export default FocusLayoutM
